export default __webpack_public_path__ + "static/media/home-img.5d0974d1.png";